// Copyright 2025. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const ButtonContainer = styled.span`
  margin-left: 5px;
`;
